import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=5da56334&scoped=true&"
import script from "./Market.vue?vue&type=script&lang=js&"
export * from "./Market.vue?vue&type=script&lang=js&"
import style0 from "./Market.vue?vue&type=style&index=0&id=5da56334&prod&lang=css&"
import style1 from "./Market.vue?vue&type=style&index=1&id=5da56334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da56334",
  null
  
)

export default component.exports